import React from 'react';
import './feedbackStatus.css';
import formattedDate from '../../utils/formattedDate.js';

const FeedbackStatus = ({status}) => {

  return (
    <div className={`FeedbackStatusPage Status${status.status.replace(' ','')}`}>
      <h3>{`${status.status} - ${formattedDate(status.date)}`}</h3>
      <p>{status.body}</p>
    </div>
  );

};

export default FeedbackStatus;


// WEBPACK FOOTER //
// ./src/components/content/feedback/highlightedFeedback/feedbackStatus/feedbackStatus.js